import React from 'react';
import { Provider } from 'react-redux';
import ReduxToastr from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import { Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';
import '~/components/dependecies/dependecies';
import '~/config/ReactotronConfig';
import AppProvider from '~/hooks';
import Routes from '~/routes';
import history from '~/services/history';
import { persistor, store } from '~/store';
import Global from '~/styles/global';
import Layout from './layout';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <Router history={history}>
          <AppProvider>
            <Layout>
              <Routes />
            </Layout>
          </AppProvider>
          <Global />
          <ToastContainer autoClose={3000} />
        </Router>
      </PersistGate>
      <ReduxToastr
        timeOut={4000}
        newestOnTop={false}
        preventDuplicates
        transitionIn="fadeIn"
        transitionOut="fadeOut"
        progressBar
        closeOnToastrClick
      />
    </Provider>
  );
};

export default App;
